(() => {
  const roots = document.querySelectorAll('[data-gcc-collection-parity]');

  for (const root of roots) {
    const nav = root.querySelector('[data-gcc-parity-nav]');
    nav?.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    const search = root.querySelector('[data-gcc-parts-search]');
    if (search) {
      const results = [...root.querySelectorAll('[data-search-text]')];
      const filter = () => {
        const query = search.value.trim().toLowerCase();
        for (const result of results) {
          result.hidden = !query || !result.dataset.searchText.includes(query);
        }
      };
      search.addEventListener('input', filter);
      filter();
    }
  }
})();
